module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "ch01"
    }
  }, [_vm._v("JUNE 2006")])]), _c('a', {
    attrs: {
      "id": "ch01"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("24/7/365")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s like she can’t breathe anymore, no matter what she does.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like everything is closing in on her, crowding her. Threatening her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The hearing. The truth coming out. Reliving Durbin’s party in front of a judge and the three bastards themselves, staring her down. Cameras following her around the second she steps outside the courtroom. Exposed as a narc, all of Fieldridge talking about it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Talking about her.")])]), _c('p', {
    staticClass: "indenta"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }, [_vm._v("For weeks, it’s on the local news. Gossip in the grocery store. Downtown. People point, murmur with heads close ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("together, those looks on their faces. Randomly coming up to her and asking invasive questions. Strangers, former classmates, leaning into her space, whispering, like they’re her closest confidantes: "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("So, what did they really do to you?")])])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indenta"
  }, [_vm._v("Janie’s not cut out for this—she’s a loner. She is underground. It’s like she hasn’t even had time to let all the other stuff sink in—the real, the important. The Janie life-changing stuff. The stuff from the green notebook.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Going blind. Losing the use of her hands.")]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("The pressure is breathtaking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She’s suffocating.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just wants to run.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hide.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So she can just be.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c53c630","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 75
// module chunks = 0